import { useState } from 'react';
import { ImagePreviewModal } from '@shared/components/ImagePreview';
import { API } from '@shared/types/api';
import { isImage } from '@shared/util/media/type';
import { notNil } from '@shared/util/notNil';
import { MBMessageBubbleAttachment } from './attachment';
import { BlinkingOpacity } from './blinkingBackground';

interface MBMessageBubbleAttachmentsProps {
  message: API.ChatMessageFragment;
  align: 'left' | 'right';
  channelSlug: string;
  blink?: boolean;
  isSent: boolean;
  onLongPress?: () => void;
  isFirstMessageInGroup: boolean;
}

export function MBMessageBubbleAttachments({
  message,
  blink,
  isFirstMessageInGroup,
  ...otherProps
}: MBMessageBubbleAttachmentsProps) {
  const [showPreviewModal, setShowPreviewModal] = useState<boolean>(false);
  const [showIndex, setShowIndex] = useState<number>(0);
  const messageHasContent = !!message.content;

  const allAttachments = message.meta.attachments.filter(notNil);
  const imageAttachments = allAttachments.filter(isImage);

  return (
    <>
      <BlinkingOpacity disabled={!blink} fill>
        {allAttachments.map((attachment, index) => {
          const isFirstAttachment = index === 0 && !messageHasContent;
          return (
            <MBMessageBubbleAttachment
              key={attachment.fileKey}
              attachment={attachment}
              message={message}
              onClick={clickedAttachment => {
                setShowIndex(imageAttachments.findIndex(i => i.url === clickedAttachment.url));
                setShowPreviewModal(true);
              }}
              isFirstMessageInGroup={isFirstMessageInGroup && isFirstAttachment}
              {...otherProps}
            />
          );
        })}
      </BlinkingOpacity>
      <ImagePreviewModal
        images={imageAttachments}
        showIndex={showIndex}
        visible={showPreviewModal}
        onClose={() => {
          setShowPreviewModal(false);
        }}
      />
    </>
  );
}
